import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PackageManager from '../../../../views/PackageManager/PackageManager';

const PackageManagerPageRoute = () => {
	

	return (		
		<Routes>
			<Route
				path=""
				element={<PackageManager />}
			/>
			
		</Routes>	
	);
};
//<Route path="/" element={<Navigate to="/package_manager" replace />} />
export default PackageManagerPageRoute;
